export default __webpack_public_path__ + "static/media/k1.4bf8dc17.jpg";